import * as actions from '../../actions'

var defaultState = null

export default function nlpStatus(state = defaultState, action) {
    switch (action.type) {

        case actions.GET_AI_STATUS:
            if (!action.error) {
                state = action.payload.data
            }
            return state

        default:
            return state

    }
}
